import script from "./AssetPropertyEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetPropertyEditForm.vue?vue&type=script&setup=true&lang=ts"

import "./AssetPropertyEditForm.vue?vue&type=style&index=0&id=92f4068e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92f4068e"]])

export default __exports__